import { FunctionComponent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const Unauthorized: FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error || "Acesso negado";
  const attemptedPath = location.state?.attemptedPath || "Página desconhecida";

  const handleGoToCreateRoom = () => {
    navigate("/private-office/external/new-create");
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/private-office/external/new-create");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-lg">
        <div className="text-6xl mb-6">🚫</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Acesso Negado</h1>
        <p className="text-gray-600 mb-6">
          Você não tem permissão para acessar esta página
        </p>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <p className="text-red-700 font-medium mb-2">{error}</p>
          <p className="text-sm text-red-600">
            <strong>Página tentada:</strong> {attemptedPath}
          </p>
        </div>

        <div className="text-sm text-gray-600 space-y-3 mb-8">
          <p className="font-medium">Usuários externos podem acessar:</p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <ul className="list-none space-y-2 text-left">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                <span>Criar nova sala privativa</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                <span>Editar salas existentes</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                <span>Deletar salas (se autorizado)</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Voltar
          </Button>

          <Button
            onClick={handleGoToCreateRoom}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Criar Nova Sala
          </Button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Se você acredita que isso é um erro, entre em contato com o suporte
            técnico.
          </p>
        </div>
      </div>
    </div>
  );
};
